export const Visibility = ({ show, children }) => {
  if (show) return <>{children}</>;
};
